import { render } from "./EventScreen.vue?vue&type=template&id=10e28f8b&scoped=true"
import script from "./EventScreen.vue?vue&type=script&lang=js"
export * from "./EventScreen.vue?vue&type=script&lang=js"

import "./EventScreen.vue?vue&type=style&index=0&id=10e28f8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e28f8b"]])

export default __exports__